// extracted by mini-css-extract-plugin
export default {"container":"ParallelEffect_container__N-UfD","parallelImageStyles":"ParallelEffect_parallelImageStyles__kIp+4"};